<template>
  <!-- 파워모드 데모: 타이핑하면 캐럿 위치에서 파티클이 터지고 콤보가 쌓인다 (vscode-power-mode UX). -->
  <power-mode
    ref="pm"
    class="pm-ta"
    :class="{ 'pm-ta--light': lightMode }"
    :preset="preset"
    :colors="colors"
    :particle-count="particleCount"
    :combo-threshold="comboThreshold"
    :combo-timeout="comboTimeout"
    :shake="shake"
    :shake-intensity="shakeIntensity"
    :show-combo="showCombo"
    :dark="dark"
    :light="light"
  >
    <textarea
      ref="ta"
      class="pm-ta__field"
      :value="value"
      :placeholder="placeholder"
      :rows="rows"
      spellcheck="false"
      @input="onInput"
    ></textarea>
  </power-mode>
</template>

<script>
import Themeable from "vuetify/lib/mixins/themeable";
import { getCaretCoordinates } from "@/utils/caretCoordinates";
// 전역 auto-register(인앱) + Storybook(비auto-register) 양쪽에서 동작하도록 명시 등록.
import PowerMode from "./PowerMode.vue";

export default {
  name: "PowerModeTextarea",
  components: { PowerMode },
  mixins: [Themeable],
  props: {
    value: { type: String, default: "" },
    placeholder: { type: String, default: "여기에 타이핑해보세요 — 콤보를 쌓으면 POWER MODE!!!" },
    rows: { type: [Number, String], default: 5 },
    preset: { type: String, default: "particles" },
    colors: { type: Array, default: undefined },
    particleCount: { type: Number, default: 10 },
    comboThreshold: { type: Number, default: 8 },
    comboTimeout: { type: Number, default: 1200 },
    shake: { type: Boolean, default: true },
    shakeIntensity: { type: Number, default: 6 },
    showCombo: { type: Boolean, default: true },
  },
  computed: {
    lightMode() {
      return !this.isDark;
    },
  },
  methods: {
    onInput(e) {
      const val = e.target.value;
      this.$emit("input", val);
      this._boomAtCaret();
    },
    _boomAtCaret() {
      const ta = this.$refs.ta;
      const root = this.$refs.pm && this.$refs.pm.$refs.root;
      if (!ta || !root) return;
      const caret = getCaretCoordinates(ta, ta.selectionEnd);
      const taRect = ta.getBoundingClientRect();
      const rootRect = root.getBoundingClientRect();
      const x = taRect.left - rootRect.left + caret.left - ta.scrollLeft;
      const y = taRect.top - rootRect.top + caret.top - ta.scrollTop + caret.height / 2;
      this.$refs.pm.trigger(x, y);
    },
  },
};
</script>

<style scoped>
.pm-ta {
  border-radius: 12px;
  overflow: visible; /* 콤보 미터가 살짝 바깥으로 나감 */
}
.pm-ta__field {
  display: block;
  width: 100%;
  box-sizing: border-box;
  padding: 14px 16px;
  border-radius: 12px;
  background: #1c1c26;
  border: 1px solid #2f2f3d;
  color: #e6e6ee;
  font-size: 15px;
  line-height: 1.6;
  font-family: inherit;
  resize: vertical;
  outline: none;
  transition: border-color 0.15s ease;
}
.pm-ta__field::placeholder {
  color: #6b6b7d;
}
.pm-ta__field:focus {
  border-color: rgba(145, 85, 253, 0.55);
}

/* light */
.pm-ta--light .pm-ta__field {
  background: #ffffff;
  border-color: #e2e0ec;
  color: #37324a;
}
.pm-ta--light .pm-ta__field::placeholder {
  color: #a29cb8;
}
.pm-ta--light .pm-ta__field:focus {
  border-color: rgba(124, 77, 255, 0.5);
}
</style>
